

































































import { Vue, Component } from 'vue-property-decorator';
import { SwipeItem, Swipe, Icon, ImagePreview } from 'vant';
import { getDetail, addShare } from '../api';
import XGplayer from '../components/XGplayer.vue';
Vue.use(Swipe).use(SwipeItem).use(Icon).use(ImagePreview);

@Component({
  components: {
    XGplayer,
  },
})
export default class Detail extends Vue {
  voteNum = '';
  detailData: any = {};
  pointOut = false;
  get detail() {
    return this.$route.query;
  }
  async created() {
    const res = await getDetail(this.detail.id as string);
    this.detailData = res.data;
  }

  onSliderClick(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }

  async onshare(){
    await addShare(this.detail.id as string);
    this.pointOut = true;
  }

}
